export enum IntercompanyLease {
    NONE = '',
    ONE = '1',
    TWO = '2'
}
